import {DASHBOARD} from '../actions/constant';

const INITIAL_STATE = {};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case DASHBOARD:
            return {...action.payload.data};
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_dashboard.js